<template>
    <div class="bulk-image-upload">
        <h3 class="text-xl font-semibold mb-4">Bulk Image Upload</h3>
        <div class="mb-4">
            <input
                type="file"
                ref="fileInput"
                @change="handleFileSelection"
                multiple
                accept="image/*"
                class="hidden"
            />
            <button
                @click="$refs.fileInput.click()"
                class="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition duration-300"
            >
                Select Images
            </button>
            <span class="ml-2">{{ selectedFiles.length }} files selected</span>
        </div>
        <div v-if="selectedFiles.length > 0" class="mb-4">
            <button
                @click="uploadImages"
                class="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-300"
            >
                Upload Images
            </button>
        </div>
        <div v-if="uploadResults.length > 0" class="mt-4">
            <h4 class="text-lg font-semibold mb-2">Upload Results:</h4>
            <ul class="list-disc pl-5">
                <li v-for="result in uploadResults" :key="result.staffId" :class="result.success ? 'text-green-600' : 'text-red-600'">
                    {{ result.staffId }}: {{ result.message }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { dataApi } from '@/api/dataManagement';

export default {
    name: 'BulkImageUpload',
    data() {
        return {
            selectedFiles: [],
            uploadResults: []
        };
    },
    methods: {
        handleFileSelection(event) {
            this.selectedFiles = Array.from(event.target.files);
        },
        async uploadImages() {
            try {
                const results = await dataApi.uploadStaffImages(this.selectedFiles);
                this.uploadResults = results;
                this.$emit('imagesUploaded');
            } catch (error) {
                console.error('Error uploading images:', error);
                // Handle error (e.g., show error message to user)
            }
        }
    }
};
</script>

